module.exports = __webpack_public_path__ + "static/media/neodove.626e4570.webp";